((homepageHeroSlider, $) => {
  'use strict';

  const $dom = {};
  const cacheDom = () => {
    $dom.homeHeroSlider = $('.js-home-hero-slider');
    $dom.videoSlides = $('.js-home-hero-video-slide');
  };

  const pauseSlideVideo = (slide) => {
    const $slide = $(slide);
    if ($slide.length <= 0 || !window.Vimeo) {
      return;
    }
    if ($slide.hasClass(`home-hero-video--block`)) {
      const $videoIframes = $slide.find(`iframe`);
      $videoIframes.each((index, iframe) => {
        const player = new Vimeo.Player(iframe);
        if (player.getPaused()) {
          return;
        }
        new Vimeo.Player(iframe).pause();
      });
    }
  };

  const playSlideVideo = (slide) => {
    const $slide = $(slide);
    if($slide.length <= 0 || !window.Vimeo) {
      return;
    }
    let breakpoint = window.State.getBreakpoint();
    if (breakpoint === `tablet`) {
      breakpoint = `desktop`;
    }
    if (!$slide.hasClass(`home-hero-video--block`)) {
      return;
    }

    const $video = $slide.find(`.home-hero-video--${breakpoint}`).length > 0 ? $slide.find(`.home-hero-video--${breakpoint}`) : $slide.find(`.home-hero-video`);
    if ($video.length <= 0) {
      return;
    }

    const $videoPoster = $video.find(`[data-video-poster]`);
    if ($videoPoster.length > 0) {
      $videoPoster.css(`opacity`, 0 );
      setTimeout(() => {
        $videoPoster.css(`display`, `none` );
      }, 800);
    }

    const $videoIframe =  $video.find(`iframe`);
    if ($videoIframe.length <= 0) {
      return;
    }

    new Vimeo.Player($videoIframe[0]).play();
  };

  const initSliderVideos = () => {
    if (!$dom.videoSlides) { return; }
    $dom.videoSlides.each((index, slide) => {
      const $slide = $(slide);
      const $heroSlider = $slide.closest(`.js-home-hero-slider`);
      if ($heroSlider.length > 0 && !$slide.hasClass(`slick-active`)) {
        return;
      }

      pauseSlideVideo($slide);
      playSlideVideo($slide);
    });
  };

  const bindUIActions = () => {
    $dom.homeHeroSlider.slick({
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      dots: true,
      arrows: true,
      accessibility: true,
    });

    $dom.homeHeroSlider.on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      const $currentSlide = $dom.homeHeroSlider.find(`[data-slick-index=${currentSlide}]`);
      const $nextSlide = $dom.homeHeroSlider.find(`[data-slick-index=${nextSlide}]`);
      pauseSlideVideo($currentSlide);
      playSlideVideo($nextSlide);
    });
  };

  $(window).on(`breakpointChange`, function() {
    initSliderVideos();
  });

  $(window).on(`VimeoLoaded`, () => {
    initSliderVideos();
  });

  const init = () => {
    cacheDom();
    bindUIActions();
  };

  homepageHeroSlider.init = init;
})((window.homepageHeroSlider = window.homepageHeroSlider || {}), jQuery);
